import { render, staticRenderFns } from "./ResponsesUserComponent.vue?vue&type=template&id=17bb8474&"
import script from "./ResponsesUserComponent.vue?vue&type=script&lang=js&"
export * from "./ResponsesUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports